<template>
  <div>
    <!-- <b-row></b-row> -->
    <b-col cols="12" md="12" class="mt-2">
      <label for="">{{ $lang.send_file }}</label>
      <fileDrag
        ref="fileDrag"
        @uploadFile="attachmentTemp"
        :acceptFormats="acceptFormats"
        :acceptFormatsInput="acceptFormatsInput"
        :multiple="true"
        :crop="false"
      />
      <filelistPorgress
        :fileUpload="fileUpload"
        @removeFile="removeFileProgress"
        @getResponseCode="filesCode"
        :attachmentTypeId="parentAttachmentTypeId"
        :showButton="false"
      />
    </b-col>
  </div>
</template>

<script>
import fileDrag from "@/components/fileManager/fileDrag";
import filelistPorgress from "@/components/fileManager/filelistPorgress";
export default {
  components: {
    fileDrag,
    filelistPorgress,
  },
  props: {
    acceptFormats: {
      type: Array,
    },
    parentAttachmentTypeId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      fileUpload: [],
      acceptFormatsInput: "",
    };
  },
  methods: {
    removeFileProgress(item) {
      let indexFile = this.fileUpload.indexOf(item);
      let response = this.responseCode.find((x) => x.name == item.name);
      let indexResponse = this.responseCode.indexOf(response);
      this.fileUpload.splice(indexFile, 1);
      this.responseCode.splice(indexResponse, 1);
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    filesCode(code) {
      this.responseCode = code;
      this.$emit("responseCode", this.responseCode);
    },
    attachmentTemp(files) {
      this.btnHidden = true;
      this.fileUpload = [...this.fileUpload, ...files];
    },
  },
};
</script>

<style></style>
